// extracted by mini-css-extract-plugin
export default {"select":"default__select___glRs2"};